export type Breakpoint = 'sm' | 'md' | 'xxl';

export const Breakpoints: Record<Breakpoint, number> = {
  sm: 576,
  md: 1024,
  xxl: 1440,
};
